export default "__VITE_ASSET__Cexb25ty__"